// @ts-nocheck
import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  Grid,
  Modal,
  Paper,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { DayPicker, getDefaultClassNames } from "react-day-picker";
import styles from "../../contractors/calendar/_components/shiftcalendar.module.css";
import pStyles from "./prebook.module.css";
import dayjs from "dayjs";
import { Close } from "@mui/icons-material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  CustomChip,
  CustomIconButton,
} from "../../../components/Custom/CustomIconButton";
import { CustomDatePicker } from "../../../components/Custom/DatePicker";
import * as Yup from "yup";
import { apiRequest } from "../../../services/apiService";
import { phoneNumberFormat } from "../../../utils/methods/formatters";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import theme from "../../../theme";
import ProfileImage from "../../../assets/images/profile-picture.png";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { createPrebookingAction } from "../../../store/actions/event/prebook";
import { alertDialogAciton } from "../../../store/actions/auth";
import LoadingOverlay from "../../../components/Custom/LoadingOverlay";
import { getUniversalDateTimeFormat } from "../../../utils/methods/universalDateTimeFormat";

// NOTE: style for modal
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  p: 4,
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  minWidth: "780px",
  zIndex: 9,
  maxHeight: "80vh",
  overflowY: "auto",
  "@media (max-width: 780px)": {
    minWidth: "400px",
    maxHeight: "90vh",
  },
};

export function generateContractorList(data) {
  if (!data) return null;

  const border = getCssVariableHandler({ variableName: "--primary-pink-hex" });

  let html = "";

  html += `
            <h4 style="color: white; text-align: left; margin-bottom: 10px; margin-top: 0px; font-weight: 500;">${data?.message ?? "No Title"}</h4>
            <table style="border-collapse: collapse; width: 100%; text-align: center; color: white; margin-bottom: 20px;">
                <thead>
                    <tr>
                        <th style="border: 1px solid ${border}; padding: 5px; background-color: #444;">Contractor Name</th>
                        <th style="border: 1px solid ${border}; padding: 5px; background-color: #444;">Date</th>
                    </tr>
                </thead>
                <tbody>
        `;

  data?.contractors?.forEach((item) => {
    html += `
                <tr>
                    <td style="border: 1px solid ${border}; padding: 5px;">${item?.name}</td>
                    <td style="border: 1px solid ${border}; padding: 5px;">${getUniversalDateTimeFormat({ dateTime: item?.date }) ?? "N/A"}</td>
                </tr>
            `;
  });

  html += `</tbody></table>`;

  return html || null;
}

export const NewPreBookModal = ({ open, handleClose, onUpdate }) => {
  const dispatch = useDispatch();
  const { addLoading } = useSelector((state) => state?.prebookContractors);

  const [searchTerm, setSearchTerm] = useState("");
  const [contractorsList, setContractorsList] = useState([]);
  const [contListLoading, setConListLoading] = useState(false);
  const validationSchema = Yup.object({
    contractorsList: Yup.array()
      .of(Yup.object())
      .min(1, "At least 1 contractor should be selected"),
    comment: Yup.string()
      .max(400, "Comment should be at most 400 characters!")
      .required("Comment is required!"),
    selectedDates: Yup.array()
      .of(Yup.string())
      .min(1, "At least one date should be selected"),
    startDate: Yup.string()
      .nullable()
      .trim()
      .when("selectDateRange", {
        is: true,
        then: (schema) => schema.required("Start date is required!"),
      })
      .test(
        "time-should-be-greater-than-today",
        "Start date cannot be a past date!",
        function (value) {
          return !value || !dayjs(value).isBefore(dayjs(), "day");
        },
      ),
    endDate: Yup.string()
      .nullable()
      .trim()
      .when("selectDateRange", {
        is: true,
        then: (schema) => schema.required("End date is required!"),
      })
      .test(
        "end-date-should-be-greater-than-start-date",
        "End date can not be before start date!",
        function () {
          return (
            !this.parent.endDate ||
            !dayjs(this.parent.endDate).isBefore(this.parent.startDate, "day")
          );
        },
      ),
    selectDateRange: Yup.bool(),
  });

  const formik = useFormik({
    initialValues: {
      selectedDates: [],
      selectDateRange: false,
      startDate: null,
      endDate: null,
      comment: "",
      contractorsList: [],
    },
    validationSchema,
    onSubmit: (values) => {
      let contractorData = [];
      values?.selectedDates?.forEach((dt) => {
        values?.contractorsList?.forEach((con) => {
          contractorData?.push({
            contractorId: con?.value,
            date: dt,
          });
        });
      });

      // api call
      dispatch(
        createPrebookingAction({
          payload: {
            data: {
              contractorData,
              comment: values?.comment,
              holdDownShift: "preBook",
            },
          },
          successCallback: (data) => {
            if (
              data?.duplicateArray?.contractors?.length > 0 ||
              data?.duplicateHoldDownArray?.contractors?.length > 0
            ) {
              dispatch(
                alertDialogAciton({
                  open: true,
                  title: "Success",
                  message: `${data?.duplicateArray ? generateContractorList(data?.duplicateArray) : ""} ${data?.duplicateArray ? "</br>" : ""} ${data?.duplicateHoldDownArray ? generateContractorList(data?.duplicateHoldDownArray) : ""}`,
                }),
              );
            } else {
              dispatch(
                alertDialogAciton({
                  open: true,
                  title: "Success",
                  message: data?.message ?? "Prebooking successful!",
                }),
              );
            }
            handleCleanDataAndClose();
            onUpdate();
          },
          failureCallback: (msg) => {
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Failure",
                message: msg ?? "Prebooking unsuccessful!",
              }),
            );
          },
        }),
      );
    },
  });

  const {
    values,
    setFieldValue,
    errors,
    handleBlur,
    touched,
    handleChange,
    handleSubmit,
  } = formik;

  const getDefaultClassName = getDefaultClassNames();
  const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  function onMultiDateSelect(e) {
    setFieldValue(
      "selectedDates",
      e?.map((d) => dayjs(d)?.format("YYYY-MM-DD")),
    );
  }

  function checkBoxClickHandler(e) {
    setFieldValue("selectDateRange", e?.target?.checked);
  }

  function deleteCurrentDateHandler(date) {
    const currDate = dayjs(date)?.format("YYYY-MM-DD");
    setFieldValue(
      "selectedDates",
      values.selectedDates?.filter(
        (dt) => dayjs(dt).format("YYYY-MM-DD") !== currDate,
      ),
    );
  }

  useEffect(() => {
    if (
      values?.startDate &&
      values?.endDate &&
      !errors?.startDate &&
      !errors?.endDate
    ) {
      const dates = [];
      let currDate = dayjs(values.startDate);
      const lastDate = dayjs(values.endDate);

      while (
        currDate.isBefore(lastDate, "day") ||
        currDate.isSame(lastDate, "day")
      ) {
        dates.push(currDate.format("YYYY-MM-DD"));
        currDate = currDate.add(1, "day");
      }

      setFieldValue("selectedDates", dates);
    }
  }, [
    values?.startDate,
    values?.endDate,
    errors?.startDate,
    errors?.endDate,
    setFieldValue,
  ]);

  function handleCleanDataAndClose() {
    formik.resetForm();
    handleClose();
  }

  async function fetchContractorsList() {
    const { response, error } = await apiRequest({
      method: "GET",
      url: `getContractors`,
      params: {
        search: searchTerm,
        // searchBy: ,
      },
      isToken: true,
    });

    if (response?.status === 200)
      setContractorsList(
        response?.data?.data?.map((con) => {
          return {
            name: `${con?.firstName} ${con?.lastName}`,
            value: con?._id,
            phone: con?.mobile,
            email: con?.email,
            image: con?.profileImage,
          };
        }),
      );
    setConListLoading(false);
  }

  useEffect(() => {
    setConListLoading(true);
    const debounce = setTimeout(() => {
      fetchContractorsList();
      clearTimeout(debounce);
    }, 300);

    return () => {
      clearTimeout(debounce);
      setConListLoading(false);
    };
    // eslint-disable-next-line
  }, [searchTerm]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Modal open={open} onClose={handleCleanDataAndClose}>
        <Box
          sx={{
            ...style,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "1rem",
          }}
          className="custom-scroll-bar"
        >
          {addLoading ? <LoadingOverlay open={true} /> : null}
          <Box className={styles.headingContainer}>
            <Typography className={styles.heading}>
              Pre book contractors
            </Typography>
          </Box>
          <Box
            sx={{
              width: "100%",
            }}
          >
            <Autocomplete
              options={contractorsList ?? []}
              multiple
              value={values?.contractorsList}
              inputValue={searchTerm}
              onInputChange={(_, newValue) => {
                setSearchTerm(newValue);
              }}
              onChange={(e, newValue) =>
                setFieldValue("contractorsList", newValue)
              }
              componentsProps={{
                paper: {
                  style: {
                    display: "block",
                    background: "black",
                    outline: "1px solid white",
                    borderRadius: "8px",
                  },
                },
              }}
              filterOptions={(option) => option}
              getOptionLabel={(option) => option?.name}
              onBlur={handleBlur}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="contractorsList"
                  onBlur={handleBlur}
                  placeholder="Type Here To Search"
                  InputLabelProps={{
                    style: { color: "white" },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      paddingY: "7px !important",
                      "& fieldset": {
                        borderRadius: "8px",
                        borderColor: "white",
                      },
                      "&:hover fieldset": {
                        borderColor: "white !important",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "white",
                      },
                      color: "white",
                    },
                    "& .MuiInputBase-input": {
                      color: "white",
                    },
                    "& .MuiAutocomplete-popupIndicator": {
                      color: "white",
                    },
                  }}
                />
              )}
              renderTags={(selected, getTagProps) =>
                selected.map((option, index) => {
                  return (
                    <CustomChip
                      key={option?.value}
                      label={
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <Avatar
                            src={option?.image}
                            alt={option?.name?.[0].toUpperCase()}
                            sx={{ width: 24, height: 24 }}
                          />
                          {option?.name}
                        </div>
                      }
                      {...getTagProps({ index })}
                      onDelete={() => {
                        setFieldValue(
                          "contractorsList",
                          values?.contractorsList?.filter(
                            (con) => con?.value !== option?.value,
                          ),
                        );
                      }}
                    />
                  );
                })
              }
              renderOption={(props, option) => {
                return (
                  <li {...props} key={option.value}>
                    <Box className={pStyles["options-parent-container"]}>
                      <img src={option.image ?? ProfileImage} />
                      <Box className={pStyles["option-container"]}>
                        <Typography color={theme.palette.green.main}>
                          Name:&nbsp;
                          <Typography
                            sx={{
                              display: "inline",
                              color: getCssVariableHandler({
                                variableName: "--font-rgb",
                              }),
                            }}
                          >
                            {option.name}
                          </Typography>
                        </Typography>
                        <Divider
                          sx={{
                            backgroundColor: getCssVariableHandler({
                              variableName: "--font-rgb",
                            }),
                          }}
                        />

                        <Box className={pStyles["phone-and-email-container"]}>
                          <Typography color={theme.palette.green.main}>
                            Phone:&nbsp;
                            <Typography
                              sx={{
                                display: "inline",
                                color: getCssVariableHandler({
                                  variableName: "--font-rgb",
                                }),
                              }}
                            >
                              {phoneNumberFormat(option.phone)}
                            </Typography>
                          </Typography>
                          <Typography color={theme.palette.green.main}>
                            Email:&nbsp;
                            <Typography
                              sx={{
                                display: "inline",
                                color: getCssVariableHandler({
                                  variableName: "--font-rgb",
                                }),
                              }}
                            >
                              {option.email}
                            </Typography>
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </li>
                );
              }}
              PaperComponent={({ children }) => {
                let noOptions =
                  children?.props?.children?.length === 0 || false;
                if (Array.isArray(children)) {
                  noOptions = children[1]?.props?.children === "No options";
                }

                return (
                  <Paper
                    style={{
                      backgroundColor: "rgba(0, 0, 0, 1)",
                      borderRadius: "12px",
                      border: "1px solid #D175B6",
                      zIndex: 20,
                      // width: "200px",
                      padding: "5px 8px",
                      color: "white",
                      whiteSpace: "no-wrap",
                      margin: "auto",
                    }}
                  >
                    {contListLoading ? (
                      <Box
                        sx={{
                          padding: "0.5rem",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <CircularProgress size={22} />
                      </Box>
                    ) : noOptions ? (
                      <Box
                        sx={{
                          padding: "0.5rem",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Typography>No options</Typography>
                      </Box>
                    ) : (
                      children
                    )}
                  </Paper>
                );
              }}
            />
            {errors?.contractorsList && touched?.contractorsList && (
              <Typography color="error">{errors?.contractorsList}</Typography>
            )}
          </Box>
          <Box className={styles["calendar-parent"]}>
            <DayPicker
              mode="multiple"
              disabled={{
                before: new Date(),
              }}
              classNames={{
                month: `${getDefaultClassName.month} ${styles.month}`,
                selected: `${getDefaultClassName.selected} ${styles.selected}`,
                chevron: `${getDefaultClassName.chevron} ${styles.chevron}`,
              }}
              required={true}
              selected={values?.selectedDates?.map((date) =>
                dayjs(date).toDate(),
              )}
              onSelect={onMultiDateSelect}
            />
            {/* NOTE: at right there we'll be the selected dates */}
            <Box
              sx={{
                maxHeight: "385px",
                overflowY: "auto",
                overflowX: "hidden",
                "&::-webkit-scrollbar": {
                  width: "8px !important",
                },
              }}
              className="custom-scroll-bar"
            >
              {values?.selectedDates?.length > 0 && (
                <Box className={styles["selected-dates-container"]}>
                  <Typography fontWeight={600}>Selected Dates</Typography>
                  <Typography></Typography>
                  {values?.selectedDates?.map((date, i) => {
                    const dateString = dayjs(date).format("ddd MM/DD/YYYY");
                    return (
                      <Box className={styles["one-date"]} key={i}>
                        <Typography className={"no-wrap"}>
                          {dateString}
                        </Typography>
                        <CustomIconButton
                          onClick={() => deleteCurrentDateHandler(date)}
                        >
                          <Close
                            sx={{
                              fontSize: "1rem",
                            }}
                          />
                        </CustomIconButton>
                      </Box>
                    );
                  })}
                </Box>
              )}
            </Box>
          </Box>

          {/* NOTE: after it will be checkbox "select a date range" */}
          <Box sx={{ px: "16px", width: "100%" }}>
            <Box className={styles["bottom-container"]}>
              <Box className={styles["date-selector-container"]}>
                <Checkbox
                  sx={{
                    padding: "0",
                    color: "white",
                  }}
                  checked={values?.selectDateRange}
                  onChange={checkBoxClickHandler}
                />
                <Typography>Select date range</Typography>
              </Box>
            </Box>

            {values?.selectDateRange && (
              <Grid
                container
                sx={{ pr: "2.5rem", marginTop: "1rem", gap: "1rem" }}
              >
                <Grid item xs={12} md={5}>
                  <Typography>Start Date:</Typography>
                  <CustomDatePicker
                    disablePast
                    fullWidth
                    onBlur={handleBlur}
                    onChange={(date) => {
                      setFieldValue("startDate", date?.format("YYYY-MM-DD"));
                    }}
                    sx={{
                      "& > .MuiInputBase-root": {
                        "& > .MuiInputBase-input": isMediumScreen
                          ? {
                              paddingLeft: "0.25rem",
                              paddingRight: "0.25rem",
                            }
                          : null,
                        border: "none !important",
                        padding: "0 0.5rem",
                      },
                      "@media (max-width: 780px)": {
                        maxWidth: "15rem",
                      },
                    }}
                    slotProps={{
                      textField: { placeholder: "Start date" },
                      actionBar: {
                        actions: ["clear"],
                      },
                    }}
                    // format={values?.startDate ? "ddd MM/DD/YYYY" : "MM/DD/YYYY"}
                  />
                  {errors?.startDate && touched.startDate && (
                    <Typography color="error">{errors?.startDate}</Typography>
                  )}
                </Grid>

                <Grid item xs={12} md={5}>
                  <Typography>End Date:</Typography>
                  <CustomDatePicker
                    disablePast
                    onBlur={handleBlur}
                    onChange={(date) => {
                      setFieldValue("endDate", date?.format("YYYY-MM-DD"));
                    }}
                    fullWidth
                    sx={{
                      "& > .MuiInputBase-root": {
                        "& > .MuiInputBase-input": isMediumScreen
                          ? {
                              paddingLeft: "0.25rem",
                              paddingRight: "0.25rem",
                            }
                          : null,
                        border: "none !important",
                        padding: "0 0.5rem",
                        "@media (max-width: 780px)": {
                          maxWidth: "15rem",
                        },
                      },
                    }}
                    slotProps={{
                      textField: { placeholder: "Start date" },
                      actionBar: {
                        actions: ["clear"],
                      },
                    }}
                    // format={values?.endDate ? "ddd MM/DD/YYYY" : "MM/DD/YYYY"}
                  />
                  {errors?.endDate && touched.endDate && (
                    <Typography color="error">{errors?.endDate}</Typography>
                  )}
                </Grid>
              </Grid>
            )}
          </Box>

          {/* NOTE: and after that a comment text box */}
          <Box className={styles["comment-container"]}>
            <Typography>Comment:</Typography>
            <TextField
              sx={{
                color: "white",
                "& fieldset": {
                  borderColor: "white !important",
                  borderRadius: "8px",
                },
              }}
              InputProps={{
                style: {
                  color: "white",
                },
              }}
              fullWidth
              name="comment"
              rows={4}
              multiline
              onBlur={handleBlur}
              value={values?.comment}
              onChange={handleChange}
            />
            {errors?.comment && touched.comment && (
              <Typography color="error">{errors?.comment}</Typography>
            )}
          </Box>

          {/* NOTE: button to submit */}
          <Box className="bottom-btn-box">
            <Button className="btn-pink" onClick={handleSubmit}>
              Submit
            </Button>
          </Box>
        </Box>
      </Modal>
    </LocalizationProvider>
  );
};

NewPreBookModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  onUpdate: PropTypes.func,
};